module.exports = __webpack_public_path__ + "static/german_gurov_photo@2x-17e7d3680b447ab1e58b2b10f3189c46.png";